import React, { useState, useEffect } from "react";
import axios from "axios";
import linkedin from "../assets/images/linkedin.svg";
import "../App.css";
import { getStrapiApis } from "../getStrapiApis";


export default function Footer() {
  const [footerOptions, setFooterOptions] = useState([]);
  const API_BASE_URL = getStrapiApis();


  const openPDF = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/policy-document?populate=policyDocuments&populate=policyDocuments.reportFile`
        );
        const footerData =
          response?.data?.data?.attributes?.policyDocuments?.map((docs) => {
            return {
              title: docs.reportName,
              id: docs.entryNo,
              reportUrl: docs.reportFile?.data?.attributes?.url,
            };
          });
        setFooterOptions(footerData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const pdfFileUrls = [
    {
      id: "1",
      title: "Privacy Policy",
      reportUrl: '../pdfs/privacy-policy.pdf',
    },
    {
      id: "2",
      title: "Legal Disclaimer",
      reportUrl:
        "../pdfs/legal-disclaimer.pdf",
    },
    {
      id: "3",
      title: "Terms of Use",
      reportUrl:
        "../pdfs/terms-of-use.pdf",
    },
    {
      id: "4",
      title: "Cookie Policy",
      reportUrl:
        "../pdfs/cookie-policy.pdf",
    },
  ];

  return (
    <div className="footer-bg">
      <div className="footer">
        <div className="footer-dynamic">
          {pdfFileUrls.map((opt) => (
            <div
              key={opt.id}
              className="footer-link"
              onClick={() => openPDF(opt.reportUrl)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  openPDF(opt.reportUrl);
                }
              }}
              aria-label={`Open ${opt.title}`}
            >
              {opt.title}
            </div>
          ))}
        </div>
        <div className="footer-static">
          <div
            className="social"
            onClick={(_) =>
              openPDF(
                "https://www.linkedin.com/company/hdfc-capital/mycompany/"
              )
            }
          >
            <img src={linkedin} alt="socialmedia" className="social-img" />
          </div>
        </div>
      </div>
    </div>
  );
}
